var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2269_25617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.22479 28.5563C5.36714 25.3555 7.26663 22.0655 10.4674 21.2078L46.8255 11.4657C50.0263 10.6081 53.3163 12.5076 54.174 15.7084L59.462 35.4438C60.3197 38.6446 58.4202 41.9346 55.2194 42.7923L18.8614 52.5344C15.6606 53.392 12.3705 51.4925 11.5129 48.2917L6.22479 28.5563Z",
    fill: "#6059FF",
    stroke: "#6059FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98438 21.7842C2.98438 18.4705 5.67067 15.7842 8.98438 15.7842H46.625C49.9387 15.7842 52.625 18.4705 52.625 21.7842V42.2158C52.625 45.5295 49.9387 48.2158 46.625 48.2158H8.98438C5.67067 48.2158 2.98438 45.5295 2.98438 42.2158V21.7842Z",
    fill: "#8984FF",
    stroke: "#F1F0FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7663 25.1144C15.5488 23.8558 17.3806 23.8558 18.1632 25.1144L19.4629 27.2048C19.7382 27.6476 20.1756 27.9654 20.6819 28.0904L23.0716 28.6805C24.5104 29.0358 25.0765 30.778 24.1213 31.9112L22.5349 33.7933C22.1988 34.192 22.0317 34.7062 22.0692 35.2263L22.2465 37.6814C22.3532 39.1596 20.8712 40.2363 19.4983 39.678L17.2181 38.7508C16.7351 38.5544 16.1944 38.5544 15.7114 38.7508L13.4312 39.678C12.0583 40.2363 10.5763 39.1596 10.683 37.6814L10.8602 35.2263C10.8978 34.7062 10.7307 34.192 10.3946 33.7933L8.80817 31.9112C7.85296 30.778 8.41903 29.0358 9.85788 28.6805L12.2476 28.0904C12.7538 27.9654 13.1912 27.6476 13.4666 27.2048L14.7663 25.1144Z",
    fill: "#FFD8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2656 29.3188L39.2055 29.3188L31.1454 29.3188",
    stroke: "#FFD8D6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1172 35.9048L37.4851 35.9048L31.136 35.9048",
    stroke: "#FFD8D6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2269_25617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsMembership);
export default __webpack_public_path__ + "static/media/products-membership.0473d32531e17fbf7778488351e0297d.svg";
export { ForwardRef as ReactComponent };